import Thing from './Thing'
import Word  from './Word'

/**
 * A website definition object.
 * @memberOf things
 */
class Website extends Thing
{
    /**
     * Creates a new Website instance.
     * @constructor
     * @param object The generic object to initialize the object the first time.
     */
    constructor( object = null )
    {
        super() ;

        /**
         * The href attribute specifies the URL of the page the link goes to.
         * @type {string}
         */
        this.href = null ;

        /**
         * The order property specifies the order of an item
         * @type {number}
         */
        this.order = 0 ;

        this.set( object ) ;
    }

    /**
     * Clear the object.
     * @return {Object} The current item reference.
     */
    clear()
    {
        super.clear() ;
        this.href  = null;
        this.order = 0 ;
        return this ;
    }

    /**
     * Returns a shallow copy of the object.
     * @return {Thing} a shallow copy of the object.
     */
    clone()
    {
        return new Website( this.toObject() ) ;
    }

    /**
     * Populate the object with specific behaviors or types. Launched by default in the constructor and in the set methods.
     * @returns {Thing} The current reference.
     */
    populate()
    {
        if( this.additionalType && !(this.additionalType instanceof Word))
        {
            this.additionalType = new Word(this.additionalType) ;
        }
        return this ;
    }

    /**
     * Returns the generic object representation of the item.
     * @return {Object} The generic object representation of the item.
     */
    toObject()
    {
        const { href, order } = this ;
        return {
            ...super.toObject() ,
            href,
            order
        }
    }
}

export default Website ;